
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getSession } from './session';

const ProtectedRoute = () => {
  const session  = getSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/projLoginPage" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
